<h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content class="spinner-container">
        <div class="spinner-background">{{spinner.value}}%</div>
        <mat-progress-spinner #spinner color="primary" mode="determinate" [value]="progressValue"></mat-progress-spinner>
    </div>
    <div mat-dialog-actions>
        <button style="margin: auto;" class="btn btn-primary" mat-button mat-dialog-close (click)="onCancelLoading()">Cancel</button>
    </div>
